import { render } from "./SiteButton.vue?vue&type=template&id=5501de97&scoped=true"
import script from "./SiteButton.vue?vue&type=script&lang=js"
export * from "./SiteButton.vue?vue&type=script&lang=js"

import "./SiteButton.vue?vue&type=style&index=0&id=5501de97&lang=css"
import "./SiteButton.vue?vue&type=style&index=1&id=5501de97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5501de97"]])

export default __exports__